/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import Constants from 'configs/Constants';
import React, { useCallback, useState } from 'react';

import thumbnailPlaceholder from 'assets/images/visual_scrubber_thumb_placeholder.png';

interface Props {
  spriteUrl?: string;
  index?: number;
  isMain?: boolean;
  isInvisible?: boolean;
  onError?: () => void;
}

export default function Thumbnail({ spriteUrl, index, isMain, isInvisible, onError }: Props) {
  const [hasError, setHasError] = useState(false);

  const hasThumbnail = spriteUrl && index !== undefined && !hasError;

  const handleError = useCallback(() => {
    setHasError(true);
    if (onError) {
      onError();
    }
  }, [onError]);

  return (
    <div
      className={`vs-thumbnail-container ${isMain ? 'main' : ''}`}
      style={{
        visibility: isInvisible ? 'hidden' : 'visible',
        position: 'relative',
        width: Constants.ACTIVE_RESOLUTION.width,
        height: Constants.ACTIVE_RESOLUTION.height,
        backgroundImage: `url(${!hasThumbnail ? thumbnailPlaceholder : ''})`,
        backgroundSize: !hasThumbnail ? '50%' : `auto auto`,
        backgroundColor: !hasThumbnail ? '#666' : undefined,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
      id={`VisualScrubber_thumbnail___${index}`}
    >
      <div
        className="vs-thumbnail"
        style={{
          position: 'absolute',
          width: Constants.ACTIVE_RESOLUTION.width * Constants.NUMBER_THUMBNAILS_PER_SPRITE,
          height: Constants.ACTIVE_RESOLUTION.height,
          left: hasThumbnail ? `-${Constants.ACTIVE_RESOLUTION.width * index}px` : 'center',
        }}
      >
        <img
          src={spriteUrl}
          alt=""
          crossOrigin="anonymous"
          onError={handleError}
          onLoad={() => setHasError(false)}
          id={`VisualScrubber_thumbnailImage___${index}`}
        />
      </div>
    </div>
  );
}
